<template>
  <modal
    name="eventModal"
    :class="'event-modal ' + customClass"
    height="auto"
    :id="modalData.modalAction"
    :width="700"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    @opened="opened"
  >
    <div class="modal-header">
      <div class="modal-header-text">
        <span>{{ modalData.title }}</span>
      </div>
      <button
        v-if="modalData.closeButton"
        @click="hideModal"
        type="button"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
    </div>
    <div class="modal-body">
      <DeleteEvent
        v-if="modalData.modalAction == actionTypes.deleteEmployer"
      ></DeleteEvent>
      <ShowEmployeeFileHistory
        v-if="modalData.modalAction == actionTypes.showEmployeeFileHistory"
        :data="actionData.data"
      ></ShowEmployeeFileHistory>
      <FileProcessingUploadError
        v-if="modalData.modalAction == actionTypes.showProcessingFileErrorList"
        :data="actionData.data"
      ></FileProcessingUploadError>
      <DeleteFileSource
        v-if="modalData.modalAction == actionTypes.deleteFileSource"
        :data="actionData.data"
      ></DeleteFileSource>
      <DeleteCertificate
        v-if="modalData.modalAction == actionTypes.deleteCertificate"
        :data="actionData.data"
      ></DeleteCertificate>
      <TerminateEmployee
        v-if="modalData.modalAction == actionTypes.terminateEmployee"
        :data="actionData.data"
      ></TerminateEmployee>
      <BlockUser
        v-if="modalData.modalAction == actionTypes.blockUser"
        :data="actionData.data"
      ></BlockUser>
      <RemoveCustomActivity
        v-if="modalData.modalAction == actionTypes.removeCustomActivity"
        :data="actionData.data"
      ></RemoveCustomActivity>
      <ConfirmDeletionActivityPhase
        v-if="modalData.modalAction == actionTypes.confirmDeletionActivityPhase"
        :data="actionData.data"
      ></ConfirmDeletionActivityPhase>
      <ConfirmDeletionLevelPath
        v-if="modalData.modalAction == actionTypes.confirmDeletionLevelPath"
        :data="actionData.data"
      ></ConfirmDeletionLevelPath>
      <BulkAddActivities
        v-if="modalData.modalAction == actionTypes.bulkAddActivities"
        :data="actionData.data"
      ></BulkAddActivities>
      <EditLogoModal
        v-if="modalData.modalAction == actionTypes.openLogoModal"
        :data="actionData.data"
      ></EditLogoModal>
      <RemoveRewardAccessToken
        v-if="modalData.modalAction == actionTypes.removeRewardAccessToken"
        :data="actionData.data"
      ></RemoveRewardAccessToken>
      <ReinstateEmployee
        v-if="modalData.modalAction == actionTypes.reinstateEmployee"
        :data="actionData.data"
      ></ReinstateEmployee>
      <DeleteConsent
        v-if="modalData.modalAction == actionTypes.deleteConsent"
        :data="actionData.data"
      ></DeleteConsent>
    </div>
    <div class="modal-footer" v-if="modalData.showFooter">
      <b-button
        v-if="modalData.btnLeft != ''"
        class="mr-3 modal-btn-left"
        type="button"
        @click="hideModal()"
      >
        <span class="modal-btn-left-text">{{ modalData.btnLeft }}</span>
      </b-button>
      <b-button
        v-if="modalData.btnRight != ''"
        class="modal-btn-right"
        type="submit"
        variant="primary"
        @click="btnAction()"
      >
        <span class="modal-btn-right-text">{{ modalData.btnRight }}</span>
      </b-button>
    </div>
  </modal>
</template>
<script>
import DeleteEvent from "./DeleteEmployer";
import ShowEmployeeFileHistory from "./ShowEmployeeFileHistory";
import FileProcessingUploadError from "./FileProcessingUploadError";
import DeleteFileSource from "./DeleteFileSource";
import DeleteCertificate from "./DeleteCertificate";
import TerminateEmployee from "./TerminateEmployee";
import BlockUser from "./BlockUser";
import RemoveCustomActivity from "./RemoveCustomActivity";
import ConfirmDeletionActivityPhase from "./ConfirmDeletionActivityPhase";
import ConfirmDeletionLevelPath from "./ConfirmDeletionLevelPath";
import BulkAddActivities from "./BulkAddActivities";
import EditLogoModal from "./EditLogoModal";
import RemoveRewardAccessToken from "./RemoveRewardAccessToken";
import ReinstateEmployee from "./ReinstateEmployee";
import DeleteConsent from "./DeleteConsent";
import consts from "../../_consts";

export default {
  name: "",
  components: {
    DeleteEvent,
    ShowEmployeeFileHistory,
    FileProcessingUploadError,
    DeleteFileSource,
    TerminateEmployee,
    BlockUser,
    DeleteCertificate,
    RemoveCustomActivity,
    ConfirmDeletionActivityPhase,
    ConfirmDeletionLevelPath,
    BulkAddActivities,
    RemoveRewardAccessToken,
    ReinstateEmployee,
    EditLogoModal,
    DeleteConsent
  },
  data() {
    return {
      actionTypes: consts.modalAction,
      modalData: {},
      actionData: {},
      isCancel: false
    };
  },
  methods: {
    hideModal() {
      this.isCancel = true;
      this.$modal.hide("eventModal");
    },
    beforeOpen(event) {
      this.modalData =
        consts.mappingModalActionToModalData[event.params.action];
      this.actionData = event.params;
    },
    opened() {
      //      this.$refs.fileHistoryContent.opened(event);
    },
    btnAction() {
      if (this.actionData.okClickHandle) {
        this.actionData.okClickHandle(this.actionData.data);
      }
      this.isCancel = false;
      this.$modal.hide("eventModal");
    },
    beforeClose() {}
  },
  computed: {
    customClass() {
      return this.modalData.customClass ? this.modalData.customClass : '';
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_core-variables";

.event-modal {
  margin: 0;
  background: transparent;

  .modal-header {
    padding: 0;
    border: 0;
    margin: 0 auto;
    width: auto;

    .line {
      box-sizing: border-box;
      height: 3px;
      width: 593px;
      border: 1px solid $grey-4;
    }
    .modal-header-text {
      height: 29px;
      // width: auto;
      color: $near-black;
      text-transform: uppercase;
      margin-top: 30px;
      margin-left: 30px;
      font-size: 24px;
      font-weight: 600;
      line-height: 1.688rem;
      letter-spacing: 0.4px;
    }
    .modal-header-change-order-text {
      margin-top: 25px;
      margin-left: 25px;
      height: 29px;
      width: auto;
      color: $near-black;
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
      text-transform: uppercase;
      letter-spacing: 0.4px;
    }
    .modal-header-line {
      box-sizing: border-box;
      height: 3px;
      width: 593px;
      border: 1px solid $grey-4;
    }
    .close {
      margin-top: 0px;
      margin-right: 5px;
      &:focus {
        outline: none;
      }
    }
  }
  .modal-body {
    width: auto;
    margin-left: 30px;
    margin-right: 30px;
    /*padding: 20px 0 0 0;*/

    .modal-body-text {
      color: $near-black;
      font-family: $font-family-main;
      font-size: 14px;
      line-height: 18px;
    }
  }
  .modal-footer {
    /*position: absolute;*/
    bottom: 0;
    right: 0;
    padding: 0;
    float: right;
    border: 0;
    .modal-btn-left {
      margin-left: 15px;
      margin-bottom: 50px;
      margin-top: 30px;
      .modal-btn-left-text {
        color: $cl-primary;
        font-family: $font-family-main;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
      }
    }
    .modal-btn-right {
      background-color: $cl-primary;
      margin-right: 50px;
      margin-bottom: 50px;
      margin-top: 30px;
      .modal-btn-right-text {
        color: $white;
        font-family: $font-family-main;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/Modal.vue